import React, { useEffect, useState } from "react";
import Header from "../components/Admin/header/Header";
import Sidebar from "../components/Admin/Sidebar/Sidebar";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Container,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DatePicker } from "@mui/x-date-pickers";
import { Search } from "lucide-react";
import {
  AddCircleOutline,
  CheckBox,
  CheckBoxOutlineBlank,
  Close,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { DOCTORS_UNIT_SETTING } from "../_mock/mock";
export default function MasterPolicyAdd() {
  const initialState = {
    active: true,
    units: false,
    units2: false,
  };
  const navigate = useNavigate();
  const [formData, setFormData] = useState(initialState);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevValue) => {
      return {
        ...prevValue,
        [name]:
          type === "checkbox"
            ? checked
            : name === "priority"
            ? Number(value)
            : value,
      };
    });
  };
  return (
    <Container maxWidth={false} disableGutters>
      <Header />
      <Box sx={{ display: "flex" }}>
        <Box>
          <Sidebar />
        </Box>

        <Box component="form" sx={{ width: "100%", pr: "90px", py: "20px" }}>
          {/* enter item details */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: "20px",
            }}
          >
            <Typography sx={{ color: "rgba(93, 106, 130, 1)", fontSize: 20 }}>
              Add Contract Details
            </Typography>
            <IconButton onClick={() => navigate(-1)}>
              <CloseIcon />
            </IconButton>
          </Box>
          {/* first box */}

          {/* second box */}

          {/* third box */}
          <Box
            sx={{
              mb: "30px",
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="policyName"
                  label="Policy Name"
                  required
                  fullWidth
                  sx={{ bgcolor: "white" }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="type"
                  label="Type"
                  required
                  fullWidth
                  sx={{ bgcolor: "white" }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="relief"
                  label=" Relief"
                  required
                  fullWidth
                  sx={{ bgcolor: "white" }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  name="schemeValidity"
                  label="Scheme Validity"
                  required
                  fullWidth
                  sx={{ bgcolor: "white" }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Grid container spacing={1}>
                  {/* saleUnit */}
                  <Grid item xs={12} sm={6}>
                    <DatePicker
                      name="schemeFrom"
                      label="Scheme From"
                      //   onChange={(newValue) =>
                      //     handleChange({
                      //       target: { name: "startDate", value: newValue },
                      //     })
                      //   }
                      slotProps={{
                        textField: { required: true, fullWidth: true },
                      }}
                      sx={{ bgcolor: "white" }}
                    />
                  </Grid>
                  {/* saleQuantity */}
                  <Grid item xs={12} sm={6}>
                    <DatePicker
                      name="schemeTo"
                      label="Scheme To"
                      //   onChange={(newValue) =>
                      //     handleChange({
                      //       target: { name: "endDate", value: newValue },
                      //     })
                      //   }
                      slotProps={{
                        textField: { required: true, fullWidth: true },
                      }}
                      sx={{ bgcolor: "white" }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={6} lg={4}>
                <FormControlLabel
                  control={<Checkbox name="active" />}
                  sx={{ height: "57px" }}
                  label="Active"
                />
              </Grid>
            </Grid>
          </Box>
          <Box
            sx={{
              border: "1px solid rgba(223, 232, 239, 1)",
              borderRadius: "8px",
              mb: "30px",
              p: "20px",
            }}
          >
            <TableContainer component={Paper}>
              <Table>
                <TableHead
                  sx={{
                    bgcolor: "#EAEAEA",
                  }}
                >
                  <TableRow>
                    <TableCell>Criteria</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>
                      <Box sx={{ p: "15px" }}>
                        <Grid container spacing={2}>
                          <Grid xs={12}>
                            <FormControlLabel
                              control={<Checkbox name="age" />}
                              sx={{ height: "57px" }}
                              label="Age"
                            />
                          </Grid>
                          <Grid xs={12}>
                            <FormControlLabel
                              control={<Checkbox name="gender" />}
                              sx={{ height: "57px" }}
                              label="Gender"
                            />
                          </Grid>
                          <Grid xs={12} sm={6} md={3}>
                            <FormControlLabel
                              control={<Checkbox name="visitType" />}
                              sx={{ height: "57px" }}
                              label="Visit Type"
                            />
                          </Grid>
                          <Grid xs={12} sm={6} md={3}>
                            <FormControlLabel
                              control={<Checkbox name="opd" />}
                              sx={{ height: "57px" }}
                              label="OPD"
                            />
                          </Grid>
                          <Grid xs={12} sm={6} md={3}>
                            <FormControlLabel
                              control={<Checkbox name="ipd" />}
                              sx={{ height: "57px" }}
                              label="IPD"
                            />
                          </Grid>
                          <Grid xs={12} sm={6} md={3}>
                            <FormControlLabel
                              control={<Checkbox name="storeBill" />}
                              sx={{ height: "57px" }}
                              label="Store Bill"
                            />
                          </Grid>
                          <Grid xs={12} sm={6} md={3}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  name="units2"
                                  checked={formData?.units}
                                  onChange={handleChange}
                                />
                              }
                              sx={{ height: "57px" }}
                              label="Unit(s)"
                            />
                          </Grid>
                          <Grid xs={12} sm={6}>
                            <Autocomplete
                              multiple
                              disabled={formData?.units === false}
                              disableCloseOnSelect
                              // limitTags={1}
                              options={DOCTORS_UNIT_SETTING || []}
                              getOptionLabel={(option) =>
                                option?.doctorName || ""
                              } // it is necessary for searching the options
                              renderInput={(params) => (
                                <TextField {...params} fullWidth />
                              )}
                              renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                  <Checkbox
                                    icon={
                                      <CheckBoxOutlineBlank fontSize="small" />
                                    }
                                    checkedIcon={<CheckBox fontSize="small" />}
                                    checked={selected}
                                    sx={{ mr: 1 }}
                                  />
                                  {option?.doctorName || ""}
                                </li>
                              )}
                              renderTags={(selected, getTagProps) =>
                                selected?.map((option, index) => (
                                  <Chip
                                    label={option?.doctorName}
                                    size="small"
                                    {...getTagProps({ index })}
                                    key={option?.id}
                                  />
                                ))
                              }
                              // value={selectedOptions || []}
                              // onChange={handleSelectionChange}
                              sx={{ minWidth: "200px" }}
                            />
                          </Grid>
                          <Grid xs={12}>
                            <FormControlLabel
                              control={<Checkbox name="doctors" />}
                              sx={{ height: "57px" }}
                              label="Doctor(s)"
                            />
                          </Grid>
                          <Grid xs={12} sm={6} md={3}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  name="units"
                                  checked={formData?.units}
                                  onChange={handleChange}
                                />
                              }
                              sx={{ height: "57px" }}
                              label="Unit(s)"
                            />
                          </Grid>
                          <Grid xs={12} sm={6}>
                            <Autocomplete
                              multiple
                              disabled={formData?.units === false}
                              disableCloseOnSelect
                              // limitTags={1}
                              options={DOCTORS_UNIT_SETTING || []}
                              getOptionLabel={(option) =>
                                option?.doctorName || ""
                              } // it is necessary for searching the options
                              renderInput={(params) => (
                                <TextField {...params} fullWidth />
                              )}
                              renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                  <Checkbox
                                    icon={
                                      <CheckBoxOutlineBlank fontSize="small" />
                                    }
                                    checkedIcon={<CheckBox fontSize="small" />}
                                    checked={selected}
                                    sx={{ mr: 1 }}
                                  />
                                  {option?.doctorName || ""}
                                </li>
                              )}
                              renderTags={(selected, getTagProps) =>
                                selected?.map((option, index) => (
                                  <Chip
                                    label={option?.doctorName}
                                    size="small"
                                    {...getTagProps({ index })}
                                    key={option?.id}
                                  />
                                ))
                              }
                              // value={selectedOptions || []}
                              // onChange={handleSelectionChange}
                              sx={{ minWidth: "200px" }}
                            />
                          </Grid>
                          <Grid xs={12}>
                            <FormControlLabel
                              control={<Checkbox name="location" />}
                              sx={{ height: "57px" }}
                              label="Location"
                            />
                          </Grid>
                        </Grid>
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          {/* save button */}
          <Box sx={{ display: "flex", justifyContent: "center", mt: "20px" }}>
            <Button
              variant="contained"
              type="submit"
              sx={{
                textTransform: "none",
                backgroundColor: "rgba(1, 121, 176, 1)",
                width: "150px",
              }}
            >
              Submit
            </Button>
          </Box>
        </Box>
      </Box>
    </Container>
  );
}
